<template>
  <div class="hubday-section">
    <div class="hubday-head">
      <i class="material-icons-outlined">book</i>Agenda des devoirs
    </div>
    <transition :name="transition" mode="out-in">
      <div
        v-if="homeworks != null"
        class="hubday-body agenda"
        v-bind:key="formatDate(date)"
      >
        <h2>
          <div>
            <div v-if="formatDate(date) == formatDate(today)">Aujourd'hui</div>
            <div v-else>
              {{
                (difference > 0 ? "Il y a " : "Dans ") +
                Math.abs(difference) +
                " jours"
              }}
            </div>
            <div
              v-if="formatDate(date) == formatDate(today)"
              v-html="textDate(date).slice(0, -1).join(' ')"
              class="smaller"
            ></div>
            <div
              v-else
              v-html="
                'Du ' +
                formatDate(date).split('-').slice(1).reverse().join('/') +
                ' au ' +
                formatDate(nextWeek).split('-').slice(1).reverse().join('/')
              "
              class="smaller"
            ></div>
          </div>
          <div class="controls">
            <button v-on:click="changePage(-14)" class="round-left">
              <i class="material-icons">chevron_left</i>
            </button>
            <button v-on:click="changePage(14)" class="round-right">
              <i class="material-icons">chevron_right</i>
            </button>
          </div>
        </h2>
        <div
          v-if="
            !Object.keys(homeworks).includes(formatDate(today)) &&
            formatDate(date) == formatDate(today)
          "
          class="noItem inline"
        >
          <i class="material-icons-outlined">book</i>Pas de devoir pour
          aujourd'hui
        </div>
        <div
          v-if="
            Object.keys(homeworks).length == 0 &&
            !(
              !Object.keys(homeworks).includes(formatDate(today)) &&
              formatDate(date) == formatDate(today)
            )
          "
          class="noItem inline"
        >
          <i class="material-icons-outlined">book</i>Pas de devoir pour cette
          période
        </div>
        <div
          v-for="workDate in Object.keys(homeworks).sort()"
          v-bind:key="workDate"
        >
          <h2 v-if="workDate != formatDate(today)">
            <div>
              <div v-if="workDate == formatDate(tomorrow)">Demain</div>
              <div
                v-html="textDate(workDate).slice(0, -1).join(' ')"
                class="smaller"
              >
                {{ workDate }}
              </div>
            </div>
          </h2>
          <div
            v-if="
              homeworks[workDate].length == 0 &&
              formatDate(tomorrow) == formatDate(workDate)
            "
            class="noItem inline"
          >
            <i class="material-icons-outlined">book</i>Pas de devoir pour demain
          </div>
          <div v-for="homework in homeworks[workDate]" v-bind:key="homework.id">
            <div class="module">
              {{
                modules.hasOwnProperty(homework.module)
                  ? homework.module +
                    " - " +
                    (modules[homework.module].shortName
                      ? modules[homework.module].shortName
                      : modules[homework.module].name)
                  : homework.module
              }}
              <i
                v-if="homework.notation == 'graded'"
                class="material-icons-outlined prefix"
                style="float: right; cursor: pointer"
                :style="{
                  color: modules.hasOwnProperty(homework.module)
                    ? modules[homework.module].color
                    : 'gray',
                }"
                title="Ce devoir est noté"
                >grading</i
              >
            </div>
            <div
              class="work"
              :style="{
                'border-left':
                  '8px solid ' +
                  (modules.hasOwnProperty(homework.module)
                    ? modules[homework.module].color
                    : 'gray'),
              }"
            >
              <p v-for="i in generateRange(0, homework.label.length-1, 1)" v-bind:key="homework.id + '.' + i" :id="homework.id + '.' + i" @click="markAsDone(homework.id + '.' + i)">{{ homework.label[i]}}</p>
            </div>
            <div v-if="homework.delivery != ''" class="delivery">
              <div>
                <i class="material-icons-outlined">{{
                  homework.delivery == "Remise en main propre"
                    ? "print"
                    : "attach_email"
                }}</i>
                <a
                  v-if="homework.link != ''"
                  :href="homework.link"
                  target="_blank"
                  >{{ homework.delivery }}</a
                >
                <span v-else>{{ homework.delivery }}</span>
              </div>
              <span class="timer">{{ homework.time }}</span>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <div class="hubday-footer">
      <transition name="fade" mode="out-in">
        <em>Dernière modification : jamais</em>
      </transition>
    </div>
  </div>
</template>

<style>
.agenda > div {
  margin-bottom: 10px;
}

.agenda > div > div {
  margin-bottom: 10px;
}

.hubday-body.agenda h2 {
  border-bottom: 1px solid #eee;
  padding-bottom: 6px;
  min-height: unset;
}

.agenda h2:not(:first-child) {
  /*border-top: 1px solid #eee;*/
  padding-top: 6px;
}

.agenda .module {
  padding-top: 3px;
}

.agenda .work {
  border-left: 8px solid red;
  padding: 6px 8px;
}

.agenda .work p {
  cursor: pointer;
}

.agenda .work p:first-child {
  margin-top: 0;
}

.agenda .work p:last-child {
  margin-bottom: 0;
}

.agenda .work p.done {
  text-decoration: line-through;
  color: #888;
  font-style: italic;
}

.delivery {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 8px;
}

.delivery span.timer {
  background-color: unset;
}

.delivery > div {
  display: flex;
}

.delivery > div i {
  padding-right: 8px;
  font-size: 24px;
}

.hubday-body.agenda {
  padding-bottom: 10px;
}
</style>

<script>
import M from "materialize-css";
import { mapState } from "vuex";

export default {
  data() {
    return {
      date: new Date(),
      today: new Date(),
      tomorrow: new Date(),
      nextWeek: new Date(),
      homeworks: null,
      transition: "fade",
      difference: 0,
    };
  },
  computed: {
    ...mapState(["modules", "agendaRef"]),
  },
  watch: {
    agendaRef() {
      this.changePage(0);
    },
  },
  methods: {
    markAsDone(workId) {
      console.log(workId);
      document.getElementById(workId).classList.toggle('done');
    },
    generateRange(min, max, step) {
      let arr = [];
      for (let i = min; i <= max; i += step) {
        arr.push(i);
      }
      return arr;
    },
    textDate(inputFormat) {
      var jours = [
        "Dimanche",
        "Lundi",
        "Mardi",
        "Mercredi",
        "Jeudi",
        "Vendredi",
        "Samedi",
      ];
      var joursCourt = [
        "Dim",
        "Lun",
        "Mar",
        "Mer",
        "Jeu",
        "Ven",
        "Sam",
      ];
      var mois = [
        "Janvier",
        "Février",
        "Mars",
        "Avril",
        "Mai",
        "Juin",
        "Juillet",
        "Août",
        "Septembre",
        "Octobre",
        "Novembre",
        "Décembre",
      ];

      var d = new Date(inputFormat);
      return [
        jours[d.getDay()],
        /*joursCourt[d.getDay()],*/
        d.getDate() == 1 ? d.getDate() + "<sup>er</sup>" : d.getDate(),
        mois[d.getMonth()],
        this.pad(d.getFullYear()),
      ];
    },
    pad(s) {
      return s < 10 ? "0" + s : s;
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    changePage(step) {
      this.transition = step < 0 ? "previous" : step > 0 ? "next" : "fade";
      this.date.setDate(this.date.getDate() + step);
      this.nextWeek.setDate(this.nextWeek.getDate() + step);

      this.difference = Math.round(
        (this.today.getTime() - this.date.getTime()) / (1000 * 3600 * 24)
      );

      var agendaRef = this.agendaRef
        .orderByChild("date")
        .startAt(this.formatDate(this.date))
        .endAt(this.formatDate(this.nextWeek));
      var self = this;
      agendaRef.on("value", function (snapshot) {
        var rawHomeworks = snapshot.val();
        self.homeworks = {};
        if (self.today == self.date) {
          self.homeworks[self.formatDate(self.today)] = [];
          self.homeworks[self.formatDate(self.tomorrow)] = [];
        }
        for (var id in rawHomeworks) {
          if (self.homeworks[rawHomeworks[id].date] === undefined)
            self.homeworks[rawHomeworks[id].date] = [];
          rawHomeworks[id]["id"] = id;
          self.homeworks[rawHomeworks[id].date].push(rawHomeworks[id]);
        }
      });
    },
  },
  beforeMount() {
    this.tomorrow.setDate(this.today.getDate() + 1);
    this.nextWeek.setDate(this.nextWeek.getDate() + 13);
  },
  mounted() {
    if (this.agendaRef != null) this.changePage(0);
  },
};
</script>